import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import EditOffIcon from "@mui/icons-material/EditOff";
import AccessAlarmsIcon from "@mui/icons-material/AccessAlarms";
import FormControlLabel from "@mui/material/FormControlLabel";
import InfoIcon from '@mui/icons-material/Info';
import UpdateHotelPolicy from "./UpdatePolicy";
import Checkbox from "@mui/material/Checkbox";
import { Button } from "@mui/material";
import Loading from "react-spinner-material";
import ENV from "../../../environment";
import axios from "axios";
import { useParams } from "react-router-dom";
import UpdateHotelCurrency from "./UpdateCurrency";

const HotelPolicy = () => {
    const { hotelid } = useParams();

    const [loading, setLoading] = useState(true);
    const [updating, setUpdating] = useState(false);
    const [currencyUpdating, setCurrencyUpdating] = useState(false);
    const [data, setData] = useState([]);
    const [currencyStatuses, setCurrencyStatus] = useState([]);

    const getData = async () => {
        setLoading(true);
        await axios
            .get(`${ENV.URL}/api/hdp/tts/adm/hotel/hotel-policy/${hotelid}`, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: sessionStorage.getItem("token"),
                    "client-id": ENV.CLIENTID,
                    "client-secret": ENV.SECRET,
                },
            })
            .then((res) => {
                setData(res.data.data);
                setLoading(false);
            })
            .catch((err) => {
                setLoading(false);
                toast.error(err?.response?.data?.errors[0]?.message || "An error occurred");
            });
    };

    const getCurrencyStatus = async () => {
        setLoading(true);
        await axios
            .get(`${ENV.URL}/api/hdp/tts/adm/hotel/${hotelid}/currency`, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: sessionStorage.getItem("token"),
                    "client-id": ENV.CLIENTID,
                    "client-secret": ENV.SECRET,
                },
            })
            .then((res) => {
                setCurrencyStatus(res.data.data);
                setLoading(false);
            })
            .catch((err) => {
                setLoading(false);
                toast.error(err?.response?.data?.errors[0]?.message || "An error occurred");
            });
    };

    useEffect(() => {
        getData();
        getCurrencyStatus();
    }, []);

    const update = () => {
        setUpdating(true);
    };

    const updateCurrency = () => {
        setCurrencyUpdating(true);
    }

    const CURRENCY_STATUS_DICTIONARY = {
        ACTIVE: "active",
        PENDING: "pending",
        CANCEL: "cancel"
    }

    return (
        <div className="container mt-3">
            {loading ? (
                <div style={{ marginTop: "100px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <Loading radius={150} color={"#1976d2"} stroke={16} visible={true} />
                </div>
            ) : (
                <React.Fragment>
                    <Button style={{ float: "right" }} variant="outlined" onClick={update}>
                        Update
                    </Button>

                    <h4 className="mt-4" style={{ marginBottom: "1rem" }}>
                        {"List of policies"}
                    </h4>
                    <div className="hc-amenity no-select">
                        {data
                            .filter((e) => e.type === "time")
                            .map((amenity) => (
                                <div className="MuiTypography-root MuiTypography-body1 MuiFormControlLabel-label css-ahj2mt-MuiTypography-root">
                                    <AccessAlarmsIcon /> {amenity.name}: {amenity.value?.slice(0, 5)}
                                </div>
                            ))}
                        {data
                            .filter((e) => e.name === "Cancel booking")
                            .map((amenity) => (
                                <div className="MuiTypography-root MuiTypography-body1 MuiFormControlLabel-label css-ahj2mt-MuiTypography-root">
                                    <EditOffIcon /> {amenity.name}:{" "}
                                    {amenity.value === "null" || amenity.value === null
                                        ? "Can always cancel"
                                        : amenity.value === "0" || amenity.value === 0
                                            ? "Imposible cancel"
                                            : `Cancel to ${amenity.value * 24} hours`}
                                </div>
                            ))}
                    </div>
                    <div className="hc-amenity no-select">
                        {data
                            .filter((e) => e.type === "boolean")
                            .map((amenity) => (
                                <div>
                                    <FormControlLabel control={<Checkbox checked={amenity.value === "true"} />} label={amenity.name} />
                                </div>
                            ))}
                    </div>
                    <div>
                        <Button style={{ float: "right" }} variant="outlined" onClick={updateCurrency}>
                            Update
                        </Button>
                        <h4 className="mt-4" style={{ marginBottom: "1rem" }}>Currencies status</h4>
                    </div>
                    {
                        <div className="hc-amenity no-select">
                            {currencyStatuses
                                .map((currency) => (
                                    <div>
                                        <FormControlLabel control={<Checkbox checked={currency.status_name === CURRENCY_STATUS_DICTIONARY.PENDING || currency.status_name === CURRENCY_STATUS_DICTIONARY.ACTIVE} />} label={`${currency.name} ( ${currency.abbreviation} )`} />
                                        {
                                            currency.status_name === CURRENCY_STATUS_DICTIONARY.PENDING && (
                                                <>
                                                    <InfoIcon style={{ color: "blue", cursor: "pointer", opacity: "0.6" }} />
                                                </>
                                            )
                                        }
                                    </div>
                                ))}
                        </div>
                    }
                    {
                        currencyStatuses.some(c => c.status_name === CURRENCY_STATUS_DICTIONARY.PENDING) && (
                            <div className="d-flex gap-1 mt-3">
                                <InfoIcon style={{ color: "blue", cursor: "pointer", opacity: "0.6" }} />
                                <p>To fully activate this currency, you will need to enter prices across all <a href={`/hotel/${hotelid}/category`}>categories</a>.</p>
                            </div>
                        )
                    }
                    <UpdateHotelPolicy open={updating} setOpen={setUpdating} data={data} getData={getData} />
                    <UpdateHotelCurrency open={currencyUpdating} setOpen={setCurrencyUpdating} currencyStatuses={currencyStatuses} getCurrencyStatus={getCurrencyStatus} />
                </React.Fragment>
            )}
        </div>
    );
};

export default HotelPolicy;
